import React from 'react'
import gql from 'graphql-tag'
import get from 'lodash.get'
import DeliveredUrl from 'components/shared/DeliveredUrl'
import DefaultProductStatus from '../../DefaultProductStatus'

const AiStudioVideoEditingProduct = ({product}) => {
  const assets = product.assets.edges.map(({ node }) => node)

  if (product.state === 'delivered') {
    return (
      <>
        {assets.map((asset, i) => {
          const label = get(asset, 'labels[0]') || 'video'
          return (
            <DeliveredUrl
              key={asset.id}
              product={product}
              getDeliveredUrl={() => asset.url}
              getTexts={
                () => ({
                  product: 'AI Studio Video',
                  watchProduct: assets.length > 1 ? `Se video (${label})` : 'Se video',
                  copiedLink: 'Lenke er kopiert',
                  descriptions: i === 0 ? [
                    'Her har du en lenke til videoen din.',
                    'Du kan dele den med hvem du vil.'
                  ] : [],
                })
              }
            />
          )
        })}
      </>
    )
  }

  return (
    <DefaultProductStatus product={product} />
  )
}

AiStudioVideoEditingProduct.fragment = gql`
  fragment AiStudioVideoEditingProduct on Product {
    ...on AiStudioVideoEditingProduct {
      assets {
        edges {
          node {
            id
            state
            ...on UrlAsset {url, labels}
          }
        }
      }
    }
  }
`

export default AiStudioVideoEditingProduct
